const config = {
    YAWN_CERTAINTY_THRESHOLD: 0.5,
    YAWN_TIREDNESS_TIME_THRESHOLD: 0.5,
    EYE_CLOSED_CERTAINTY_THRESHOLD: 0.5,
    EYE_CLOSED_ASLEEP_TIME_THRESHOLD: 0.5,
    EYE_BLINKED_CERTAINTY_THRESHOLD: 0.5,
    YAW_ANGLE_ALERT_THRESHOLD: 0.5,
    PITCH_ANGLE_MIN_ALERT_THRESHOLD: 0.5,
    PITCH_ANGLE_MAX_ALERT_THRESHOLD: 0.5,
    YAW_ANGLE_MIN_ALERT_THRESHOLD: 0.5,
    YAW_ANGLE_MAX_ALERT_THRESHOLD: 0.5,
    PITCH_ANGLE_MIN_EMOTION_FILTER_THRESHOLD: 0.5,
    PITCH_ANGLE_MAX_EMOTION_FILTER_THRESHOLD: 0.5,
    YAW_ANGLE_MIN_EMOTION_FILTER_THRESHOLD: 0.5,
    YAW_ANGLE_MAX_EMOTION_FILTER_THRESHOLD: 0.5,
    ROLL_ANGLE_MIN_EMOTION_FILTER_THRESHOLD: 0.5,
    ROLL_ANGLE_MAX_EMOTION_FILTER_THRESHOLD: 0.5,
    DETECTION_SCORE_FILTER_ACTIVE: true,
    DETECTION_SCORE_THRESHOLD: .75,
    MASK_MODEL_ACTIVE: true,
    MASK_ON_CERTAINTY_THRESHOLD: 0.85,
    HEAD_ANGLE_EMOTION_FILTER_ACTIVE: true,
    LIGHT_FILTER_ACTIVE: true,
    LIGHT_FILTER_THRESHOLD: 10,
    HAND_FILTER_ACTIVE: true,
    FILTER_BOX_SIZE_ACTIVE: true,
}

export default config;
